import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)
class Animations {
  constructor() {
    const footerLinks = document.querySelectorAll('.c-footer__menu a')
    footerLinks.forEach((link) => {
      link.classList.add('line-effect')
    })

    this.reveals()
  }

  reveals() {
    this.headings = document.querySelectorAll('.line-effect')
    this.headings.forEach((element) => {
      element.style.overflowX = 'hidden'
      let split
      const tweens = []
      const isBefore = element.getBoundingClientRect().bottom < window.innerHeight

      const tl = () => {
        split = new SplitText(element, { type: 'lines' })
        gsap.set(element, { autoAlpha: 1 })
        split.lines.forEach((line, i) => {
          tweens[i] = gsap.from(line, {
            duration: 1,
            delay: isBefore ? 0.6 : 0.3,
            y: 25,
            opacity: 0,
            stagger: 0.1,
            ease: 'power4.out',
            scrollTrigger: {
              trigger: line,
              start: 'top bottom',
            },
          })
        })
      }

      tl()

      window.addEventListener('resize', () => {
        if (window.innerWidth < 900) return
        split.revert()
        tweens.forEach((tween) => tween.kill())
        tl()
      })
    })

    this.fades = document.querySelectorAll('.fade-effect')
    this.fades.forEach((element) => {
      element.style.overflowX = 'hidden'
      let split
      const tweens = []

      const tl = () => {
        split = new SplitText(element, {
          type: 'lines',
        })
        gsap.set(element, { autoAlpha: 1 })
        split.lines.forEach((line, i) => {
          tweens[i] = gsap.from(line, {
            duration: 1,
            delay: 0.3,
            opacity: 0,
            scrollTrigger: {
              trigger: line,
              start: 'top bottom',
            },
          })
        })
      }

      tl()

      window.addEventListener('resize', () => {
        if (window.innerWidth < 900) return
        split.revert()
        tweens.forEach((tween) => tween.kill())
        tl()
      })
    })

    const logos = document.querySelectorAll('.c-logo')
    logos.forEach((logo) => {
      const paths = logo.querySelectorAll('path')
      paths.forEach((path, i) => {
        gsap.from(path, {
          duration: 1,
          delay: i * 0.1,
          y: 25,
          opacity: 0,
          stagger: 0.1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: path,
            start: 'top bottom',
          },
        })
      })
    })
  }
}

export default Animations
